import HarvardUniversity from "../assets/university_logos/harvard_university.png";
import OxfordUniversity from "../assets/university_logos/University of Oxford.png";
import StanfordUniversity from "../assets/university_logos/Stanford University.png";
import CambridgeUniversity from "../assets/university_logos/University of Cambridge.png";
import MassachusettsUniversity from "../assets/university_logos/Massachusetts Institute of Technology (MIT).png";
import TokyoUniversity from "../assets/university_logos/University of Tokyo.png";
import MelbourneUniversity from "../assets/university_logos/University of Melbourne.png";
import ETHUniversity from "../assets/university_logos/ETH Zurich.png";
import SingaporeUniversity from "../assets/university_logos/National University of Singapore.png";
import CaliforniaUniversity from "../assets/university_logos/University of California, Berkeley.png";

export const universities = [
  {
    name: "Harvard University",
    logo: HarvardUniversity,
    country: "United States",
  },
  {
    name: "University of Oxford",
    logo: OxfordUniversity,
    country: "United Kingdom",
  },
  {
    name: "Stanford University",
    logo: StanfordUniversity,
    country: "United States",
  },
  {
    name: "University of Cambridge",
    logo: CambridgeUniversity,
    country: "United Kingdom",
  },
  {
    name: "MIT",
    logo: MassachusettsUniversity,
    country: "United States",
  },
  {
    name: "University of Tokyo",
    logo: TokyoUniversity,
    country: "Japan",
  },
  {
    name: "University of Melbourne",
    logo: MelbourneUniversity,
    country: "Australia",
  },
  {
    name: "ETH Zurich",
    logo: ETHUniversity,
    country: "Switzerland",
  },
  {
    name: "National University of Singapore",
    logo: SingaporeUniversity,
    country: "Singapore",
  },
  {
    name: "University of California, Berkeley",
    logo: CaliforniaUniversity,
    country: "United States",
  },
];
